export default '/build/b33884ed.svg'